import React, { useState, useEffect } from "react";
import { MAGIC_PHOTOS } from "../data/cruiseData";

const SLIDES = [
 { src: MAGIC_PHOTOS.hensBridal, label: "Hens Cruise · Opera House · Bridge" },
 { src: MAGIC_PHOTOS.hensPinkParty, label: "Hens Squad · Sydney Harbour" },
 { src: MAGIC_PHOTOS.corporateLounge, label: "Corporate · Magic Lounge" },
 { src: MAGIC_PHOTOS.fireworksCollage, label: "NYE & Evenings · Sydney Lights" },
 { src: MAGIC_PHOTOS.corporateCollage, label: "Magic · Every Occasion" },
 { src: MAGIC_PHOTOS.championToast, label: "Sunset · Champagne · Sydney" },
];

export default function HeroSlider() {
 const [i, setI] = useState(0);
 useEffect(() => {
 const t = setInterval(() => setI((p) => (p + 1) % SLIDES.length), 5500);
 return () => clearInterval(t);
 }, []);
 return (
 <div className="absolute inset-0" data-testid="hero-slider">
 {SLIDES.map((s, idx) => (
 <div key={idx} className={`absolute inset-0 transition-opacity duration-[1600ms] ease-in-out ${i === idx ? "opacity-100" : "opacity-0"}`}>
 <img src={s.src} alt={s.label} className="w-full h-full object-cover" loading={idx === 0 ? "eager" : "lazy"} />
 </div>
 ))}
 {/* Strong left-to-right gradient for headline legibility + soft bottom fade to cream */}
 <div className="absolute inset-0 bg-gradient-to-r from-[hsla(222,45%,8%,0.78)] via-[hsla(222,45%,8%,0.55)] to-[hsla(222,45%,8%,0.10)]" />
 <div className="absolute inset-x-0 bottom-0 h-44 bg-gradient-to-b from-transparent to-[hsl(45,100%,97%)]" />
 <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-[hsla(222,45%,8%,0.45)] to-transparent" />

 {/* Slide pills */}
 <div className="absolute bottom-8 right-6 flex items-center gap-2 z-30">
 {SLIDES.map((_, idx) => (
 <button key={idx} onClick={() => setI(idx)} aria-label={`Slide ${idx + 1}`} className={`h-1 rounded-full transition-all duration-500 ${i === idx ? "w-10 bg-white" : "w-3 bg-white/50 hover:bg-white/80"}`} data-testid={`hero-slide-dot-${idx}`} />
 ))}
 </div>
 <div className="absolute bottom-8 left-6 z-30">
 <span className="text-white/85 text-[10px] uppercase tracking-[0.3em] font-bold">{SLIDES[i].label}</span>
 </div>
 </div>
 );
}
